import React, { useState } from "react";
import { Navbar, Image, Container, Row, Col } from "react-bootstrap";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import "./index.css";

export default function Header({ isMobile }) {
  const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if (window.scrollY >= 20) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
  return (
    <Container>
      <Navbar expand="lg"
        fixed="top"
        bg="dark"
        variant="dark"
        className={navbar ? 'navbar active' : 'navbar'}>
        <Container>
          <Row className="headerlogos">
            <Col xl={6}>
              <a href="https://www.swmc.com/" target="_blank">
                <Image src={"https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"}
                  alt="Sun West logo" className="sunwest-logo mt-2" />
              </a>
            </Col>
            <Col xl={5}>
              <a href="https://www.swmc.com/angelai-university" target="_blank">
                <Image src={"https://resources.swmc.com/morgan-university/morgan-university.webp"}
                  alt="AngelAi University logo" className="morgan-university-logo mt-2" />
              </a>
            </Col>
          </Row>
        </Container>
        <div className="desktopaccesibity">
        {!isMobile && (
          <UserWayAccessibilityMenu color="white" width={40} height={40}  />
        )}
          </div>
      </Navbar>
      <div className="mobileaccesibity">
      {!isMobile && (
          <UserWayAccessibilityMenu color="white" width={40} height={40}  />
        )}
        </div>
    </Container>
  );
}
